/*
 * Carga diferida de videos de fondo (landing Campamento Mini Yoguis).
 * Uso: <video data-lazy-video data-poster="..." loop muted playsinline preload="none">
 *        <source data-src="video.mp4" type="video/mp4">
 *      </video>
 * El poster y el video se cargan recién cuando el video está a ~600px de
 * entrar en pantalla; se reproduce mientras está visible y se pausa al salir.
 */
(function () {
  if (window.__campamentoLazyVideo) return;
  window.__campamentoLazyVideo = true;

  function init() {
    var videos = document.querySelectorAll('video[data-lazy-video]');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function load(video) {
      if (video.dataset.lazyLoaded) return;
      video.dataset.lazyLoaded = 'true';
      if (video.dataset.poster) video.poster = video.dataset.poster;
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
      });
      video.load();
    }

    function play(video) {
      if (reducedMotion) return;
      var promise = video.play();
      if (promise && promise.catch) promise.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        load(video);
        play(video);
      });
      return;
    }

    var nearObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            load(entry.target);
            nearObserver.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '600px 0px' }
    );

    var visibleObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            load(video);
            play(video);
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { threshold: 0.1 }
    );

    videos.forEach(function (video) {
      nearObserver.observe(video);
      visibleObserver.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
